import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { InputAdornment, TextField, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import el from 'date-fns/esm/locale/el/index.js';

interface PlannerFieldProps {
    parentClasses: ClassNameMap,
    setValue: any,
    value: string,
    labelText: string,
    lastElement?: boolean,
    description: string|null,
    sharingrole:string,
    Placeholder:string
}
const PlannerTextField: React.FC<PlannerFieldProps> = ({
    parentClasses,
    setValue,
    value,
    labelText,
    lastElement,
    description,
    sharingrole,
    Placeholder
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        {
            setValue(event.target.value);
        }
    };

    return (
        <div className={parentClasses.inputRow}>
            <div className={parentClasses.labelText}>
                {labelText}
                <span>
                    <Tooltip title={""}>
                        <InfoOutlinedIcon className={parentClasses.labelIcon} />
                    </Tooltip>
                </span>
            </div>
            <div className={parentClasses.selectField}>
                <TextField
                    InputProps={{
                        classes: { root: parentClasses.textFieldInput },
                      //  endAdornment: <InputAdornment position="end"></InputAdornment>
                    }}
                    variant='outlined'
                    type="text"                 
                    value={value}   
                    placeholder={Placeholder}           
                    onChange={handleChange}
                />
            </div>
        </div>
    );
}

export default PlannerTextField;